module.exports = __webpack_public_path__ + "img/profile-blue.5ab179d3.svg";